import Vue from "vue"
import Vuex from "vuex"
import router from "./router"
import i18n from "./i18n.js"
import _ from "lodash"
import api from "@/api"
import moment from "moment"

Vue.use(Vuex)

const APP_NAME = "bikenta-app"

export default new Vuex.Store({
  state: {
    loaded: false,
    session: null,
    locales: ["es", "gl", "pt"],
    locale: "es",
    sessionName() {
      return [window.location.hostname, APP_NAME].join(":")
    },
    notifications: [],
    enquiryComments: [],
    incidence: Object,
    parcel: Object,
    hideFooter: null
  },
  actions: {
    load({ dispatch, state }) {
      const sessionData = localStorage.getItem(state.sessionName())
      const locale = localStorage.getItem(`${state.sessionName()}.locale`)
      if (sessionData) {
        state.session = JSON.parse(sessionData)
      }
      if (locale) {
        dispatch("setLocale", locale)
      }
      state.loaded = true
    },
    logIn({ state }, data) {
      state.session = data
      localStorage.setItem(state.sessionName(), JSON.stringify(state.session))
      let params = { name: "home" }
      if (data.next) {
        params = { path: data.next }
      }
      router.push(params)
    },
    logOut({ state }, next) {
      state.session = null
      localStorage.removeItem(state.sessionName())
      const query = next && next.path ? { next: next.path } : {}
      router.push({
        name: "login",
        query: query,
      })
    },
    setLocale({ state }, locale) {
      i18n.locale = state.locale = locale
      localStorage.setItem(`${state.sessionName()}.locale`, locale)
    },
    removeNotification({ state }, key) {
      state.notifications.splice(key, 1)
    },
    loadComments({ commit }, enquiryId) {
      return api.getEnquiry(enquiryId).then((response) => {
        commit("setEnquiryComments", response.data.comments)
      })
    },
    getIncidence({ commit }, incidenceId) {
      return api.getIncidence(incidenceId).then((response) => {
        commit("setIncidence", response.data)
      })
    },
    loadParcel({commit}, parcelId) {
      return api.getParcel(parcelId).then((response) => {
        commit("setParcel", response.data)
      })
    }
  },
  getters: {
    isAuthenticated(state) {
      return state.session !== null
    },
    token(state) {
      return state.session ? state.session.token : null
    },
    userFullname(state) {
      const name = _.get(state, "session.name", "")
      const lastName = _.get(state, "session.last_name", "")
      return `${name} ${lastName}`
    },
    otherLocales(state) {
      return state.locales.filter(lang => lang !== i18n.locale)
    },
    currentLocale(state) {
      return state.locale
    },
    getComments(state) {
      const comments = []
      const dates = []
      // Get list of dates of messages
      state.enquiryComments.forEach((comment) => {
        const formatDate = moment(comment.created_on).format("DD/MM/YYYY")
        if (!dates.includes(formatDate)) {
          dates.push(formatDate)
        }
      })
      // Generate list of messages separated by dates
      dates.forEach((date) => {
        comments.push({
          date: date,
          messages: state.enquiryComments.filter(
            (comment) => moment(comment.created_on).format("DD/MM/YYYY") === date
          ),
        })
      })

      return comments
    },
    getCountMessages(state, getters) {
      // @TODO Should count unread messages instead of total messages.
      return state.enquiryComments.filter(comment => {
        const formatName = `${comment.user.first_name} ${comment.user.last_name}`
        if (getters.userFullname !== formatName) {
          return true
        }
      }).length
    },
  },
  mutations: {
    windowOpen(state, href) {
      window.open(href, "_blank")
    },
    error(state, text) {
      state.notifications.push({ type: "warning", text: text, active: true })
    },
    setEnquiryComments(state, data) {
      state.enquiryComments = data
    },
    setIncidence(state, data) {
      state.incidence = data
    },
    setParcel(state, data) {
      state.parcel = data
    },
    setHideFooter(state, status) {
      state.hideFooter = status
    }
  },
})
